import { Component, OnInit } from '@angular/core';
import { SharedConfig } from '@takectrl-multiapp/svcs-share-config';
import '@lottiefiles/lottie-player';
import { BUSNThirdPartyService } from '@takectrl-multiapp/svcs-core-business';
import { BUSNCommunicationService } from 'libs/svcs-core-business/src/lib/services/busn-communication.service';
@Component({
  selector: 'kingprice-wallet-animation',
  standalone: false,
  templateUrl: './kingprice-wallet-animation.component.html',
  styleUrls: ['./kingprice-wallet-animation.component.scss'],
})
export class KingpriceWalletAnimationComponent implements OnInit {
  showAn: boolean = true;
  insurerPopup: boolean = false;
  constructor(public sharedConfig: SharedConfig, public busnThirdPartyService: BUSNThirdPartyService, private readonly busnCommService: BUSNCommunicationService) {}

  ngOnInit(): void {}

  showIntercom() {
    this.busnCommService.openContactCardPopup()
  }

  // TODO: USE BELOW TO CLOSE INSURER POPUP

  closeInsurerPopup() {
    SharedConfig.insurerPopup = false;
  }
}
